export default "__VITE_PUBLIC_ASSET__9ca3652e__"